import { useAppSelector } from 'redux/use-hooks';

import { selectTokensWithMetadataForAccountId } from 'redux/slices/tokens';
import compare from 'utils/compare';

import config from 'config';
const { OPN_CONTRACT, OCC_CONTRACT,USDC_CONTRACT, NEAR_TOKEN_ID } = config;

import selectNEARAsTokenWithMetadata from 'redux/selectors/crossStateSelectors/selectNEARAsTokenWithMetadata';

export const useFungibleTokensIncludingNEAR = function () {
  const NEARAsTokenWithMetadata = useAppSelector(selectNEARAsTokenWithMetadata);
  const fungibleTokens = useAppSelector(selectTokensWithMetadataForAccountId);

  const sortingOrder = {
    [OPN_CONTRACT]: 1,
    [OCC_CONTRACT]: 2,
    [USDC_CONTRACT]: 3,
    [NEAR_TOKEN_ID]: 4
  };

  fungibleTokens.sort(compare({ key: 'contractName', sortingOrder }));
  return [...fungibleTokens, NEARAsTokenWithMetadata];
};
